import React from 'react';
import { BaasicTable, Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { PalletizeFulfillmentOrder, CreatePallet } from 'modules/order/pages';
import ReactTooltip from 'react-tooltip';

const PalletizingModeTemplate = ({
	palletizingModeViewStore,
	palletizingModeViewStore: { loading, newPallet, data, tableData },
	t,
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<div>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.PALLETIZINGMODE.TITLE')}</h3>
				</div>
				{!newPallet && <PalletizeFulfillmentOrder store={palletizingModeViewStore} />}
				{newPallet && <CreatePallet store={palletizingModeViewStore} />}
				{data && data.length != 0 && (
					<div className="ReactModal__body ReactModal__body--white ReactModal--palletizing">
						<div className="separator--primary spc--bottom--med"></div>
						<div className="spc--bottom--sml">
							<BaasicTable
								{...{
									tableData,
									palletizingModeViewStore,
									actions: palletizingModeViewStore,
								}}
								data={data.slice()}
							/>
						</div>
					</div>
				)}
			</div>
			<ReactTooltip />
		</section>
	);
};

export default defaultTemplate(PalletizingModeTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/PalletizingModeTemplate.jsx